/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConnectMixin from 'app/mixins/ConnectMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import * as _ from 'underscore';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import StyledSelect from 'app/components/common/StyledSelect.jsx';

class BlueskyCreds extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            serviceId: this.props.app.config.constants.POST_SVC_BLUESKY,
            provider: 'bsky.social',
            handle: '',
            password: '',
            providerError: '',
            handleError: '',
            passwordError: '',
            apiError: '',
            isWorking: false
        };

        this.connectBluesky = this.connectBluesky.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.closeAction = this.closeAction.bind(this);
        this.buttonRef = React.createRef();

    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown);

        if (this.props.handle !== undefined && this.state.handle === '') {
            this.setState({
                handle: this.props.handle
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        const clearSocialErrors = () => {
            this.props.deleteApiError(['SOCIAL_CREATE']);
        };

        if (prevProps && ((prevProps.app.loading.SOCIAL_CREATE === true && this.props.app.loading.SOCIAL_CREATE === false) ||
            (prevProps.app.loading.SOCIAL_UPDATE === true && this.props.app.loading.SOCIAL_UPDATE === false))) {

            let errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

            const clearSocialErrors = () => {
                this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);
            };

            if (errors.length) {
                if (this.props.isDuplicateSocial()) {
        			let duplicateSocial = {};
                    for (let i = 0; i < this.props.app.errors.api.length; ++i) {
                        if (this.props.app.errors.api[i].type === 'SOCIAL_CREATE' || this.props.app.errors.api[i].type === 'SOCIAL_UPDATE') {
                            duplicateSocial = this.props.app.errors.api[i].post;
                            duplicateSocial.force = true;
                        }
                    }

        			this.props.showDuplicateSocialModal(duplicateSocial, {
        				confirm: clearSocialErrors,
        				cancel: clearSocialErrors
        			});

        		} else if (this.props.isOverTheLimit()) {
        			if (this.props.appName === "dlvr") {
        				this.props.showUpgradeModal(() => {
        					this.props.closeAllModals();
        				}, null, errors, 'social_error');
        			} else {
        				this.props.showClientSocialModal({
        					confirm: clearSocialErrors
        				});
        			}

        		} else if (this.props.isBlacklisted() && !this.state.modalUp) {
        			this.props.showBlacklistModal({
        				confirm: clearSocialErrors,
        				cancel: clearSocialErrors
        			});

        		} else {

                    let action = (this.props.context === 'reconnect') ? 'reconnect' : 'connect',
                        showPermsError = false;

                    for (let i = 0; i < errors.length; ++i) {
                        if (errors[i].errors.creds !== undefined) {
                            this.setState({
                                apiError: `Unable to ${action} your social. Invalid credentials.`
                            });
                        }
                        if (errors[i].errors.perms !== undefined && errors[i].errors.perms.code !== undefined && errors[i].errors.perms.code === 2023) {
                            showPermsError = true;
                        }
                        if (errors[i].errors.validation !== undefined) {
                            let keys = Object.keys(errors[i].errors.validation),
                                otherErrors = [];

                            for (let j = 0; j < keys.length; ++j) {
                                if (_.isString(errors[i].errors.validation[keys[j]])) {
                                    otherErrors.push(errors[i].errors.validation[keys[j]]);
                                }
                            }

                            this.setState({
                                apiError: otherErrors.join("\n")
                            });

                        }
                    }

                    if (showPermsError) {
                        this.props.showUpgradeModal(() => {
                            clearSocialErrors();
                            this.props.closeAllModals();
                        }, null, errors, 'bluesky');
                    }

                    this.props.deleteApiError(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

        		}

            } else {
                this.props.closeAllModals();
                if (this.props.context === 'reconnect') {
                    this.props.addMessage(UserMessages.generateMessage(UserMessages.social.reauthorized, 'SOCIAL_UPDATE'));
                }
                if (this.props.successCallback !== undefined && typeof this.props.successCallback === "function") {
                    this.props.successCallback();
                }
            }

            this.setState({
                isWorking: false
            });

        }

    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown);
    }

    connectBluesky() {
        let apiError = '',
            providerError = '',
            handleError = '',
            passwordError = '',
            constants = this.props.app.config.constants,
            isWorking = this.state.isWorking;

        if (isWorking) {
            return;
        }

        if (this.state.provider.trim() === '') {
            providerError = "A Bluesky provider is required";
        }

        if (this.state.handle.trim() === '') {
            handleError = "Your Bluesky handle is required";
        }

        if (this.state.password.trim() === '') {
            passwordError = "App Password is required";
        }

        if (this.state.password.match(/[\w]{4}-[\w]{4}-[\w]{4}-[\w]{4}/ig) === null) {
            passwordError = "The App Password should have the form 'XXXX-XXXX-XXXX-XXXX'.";
        }

        if (!providerError && !handleError && !passwordError) {
            if (this.props.context !== undefined && this.props.context === "reconnect") {
                this.props.updateSocial({
                    id: this.props.paId,
                    creds: {
                        provider: this.state.provider.trim(),
                        handle: this.state.handle.trim(),
                        password: this.state.password.trim()
                    },
                    activeFlag: 1,
                    action: 'UPDATE'
                });
                isWorking = true;
            } else {
                let data = {
                    psID: constants.POST_SVC_BLUESKY,
                    creds: {
                        provider: this.state.provider.trim(),
                        handle: this.state.handle.trim(),
                        password: this.state.password.trim()
                    },
                    action: 'CREATE'
                };

                if (this.props.routeId !== undefined && this.props.routeId) {
                    data.rID = parseInt(this.props.routeId);
                }

                if (this.props.setNewSocial !== undefined && _.isFunction(this.props.setNewSocial)) {
                    this.props.setNewSocial(data);
                }
                
                this.props.createSocial(data);
                isWorking = true;
            }

        }

        this.setState({
            apiError,
            providerError,
            handleError,
            passwordError,
            isWorking
        });

    }

    onKeyDown(e) {
        if (e.key === 'Enter') {
            e.preventDefault();

            if (this.buttonRef.current) {
                this.buttonRef.current.click();
            }

        } else if (e.key === 'Escape') {
            this.closeAction(e);
        }
    }

    closeAction(e) {
        e.preventDefault();

        let constants = this.props.app.config.constants;

        if (this.props.context === 'onboarding' || this.props.context === 'reconnect') {
            this.props.closeAllModals();
        }

        if (!this.props.router.location.pathname.match("/config/social") &&
            !this.props.router.location.pathname.match("/content/post") &&
            _.findWhere(this.props.socials.counts, {type: constants.POST_SVC_BLUESKY}) !== undefined) {
            this.props.switchView("chooseAcct", constants.POST_SVC_BLUESKY);
        } else {
            this.props.switchView("chooseType");
        }

    }

    render () {
        let constants = this.props.app.config.constants,
            connectClass = 'btn-primary reverse-fixed active',
            connectAction = this.connectBluesky,
            providerError = null,
            handleError = null,
            passwordError = null,
            apiError = null,
            buttonLabel = "Connect";

        // if (this.state.provider !== '' && this.state.handle !== '' && this.state.password !== '') {
        //     connectClass = 'btn-primary fixed active';
        //     connectAction = this.connectBluesky;
        // }

        if (this.props.context === "reconnect") {
            buttonLabel = "Reconnect";
        }

        if (this.state.apiError) {
            apiError = (
                <div className="fieldset-error">
                    {this.state.apiError}
                </div>
            );
        }

        if (this.state.providerError) {
            providerError = (
                <div className="fieldset-error">
                    {this.state.providerError}
                </div>
            );
        }

        if (this.state.handleError) {
            handleError = (
                <div className="fieldset-error">
                    {this.state.handleError}
                </div>
            );
        }

        if (this.state.passwordError) {
            passwordError = (
                <div className="fieldset-error">
                    {this.state.passwordError}
                </div>
            );
        }

        return (
            <div className="social-connector-wrapper get-bluesky-creds">
                <div className="bluesky-form">
                    <form>
                        {apiError}
                        <fieldset>
                            <legend>Service</legend>
                            bsky.social
                        </fieldset>
                        <fieldset>
                            <legend>Bluesky Handle<HelpButton which="blueskyProvider"/></legend>
                            {handleError}
                            <UncontrolledTextInput
                                name="blueskyHandle"
                                className="text-input seventyfive"
                                placeholder="@username.bsky.social"
                                defaultValue={this.state.handle}
                                autoComplete="off"
                                onChange={(e) => {
                                    if (e.target.value !== undefined) {
                                        this.setState({
                                            handle: e.target.value
                                        });
                                    }
                                }}/>
                        </fieldset>
                    </form>
                    <form>
                        <fieldset>
                            <legend>Bluesky App Password<HelpButton which="blueskyPassword"/></legend>
                            {passwordError}
                            <UncontrolledTextInput
                                name="blueskyPassword"
                                className="text-input seventyfive"
                                isPassword={true}
                                autoComplete="new-password"
                                onChange={(e) => {
                                    if (e.target.value !== undefined) {
                                        this.setState({
                                            password: e.target.value
                                        });
                                    }
                                }}/>
                                <p className="help-text bluesky">You'll need to generate a unique password for dlvr.it. <a target="_blank" href="https://bsky.app/settings/app-passwords">Generate in Bluesky</a></p>
                        </fieldset>
                    </form>
                </div>
                <div className="spread-buttons">
                    <button className="btn-primary reverse-fixed" onClick={this.closeAction}>
                        {"< go back"}
                    </button>
                    <button ref={this.buttonRef} className={connectClass} onClick={connectAction} data-direct={true}>
                        {buttonLabel}
                    </button>
                </div>
            </div>
        );
    }
};

export default BlueskyCreds;
